import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { CarouselModule } from 'primeng/carousel';
import { AutoFocusModule } from 'primeng/autofocus';
import { DropdownModule } from 'primeng/dropdown';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';
import { StepperModule } from 'primeng/stepper';

const primengModules = [
  TableModule,
  MenubarModule,
  ToastModule,
  DropdownModule,
  ButtonModule,
  InputTextModule,
  MessagesModule,
  InputNumberModule,
  DialogModule,
  AccordionModule,
  ConfirmDialogModule,
  CalendarModule,
  SliderModule,
  CarouselModule,
  TabViewModule,
  AutoFocusModule,
  FileUploadModule,
  StepperModule,
];
@NgModule({
  declarations: [],
  exports: [primengModules],
  imports: [CommonModule, primengModules],
  providers: [MessageService, ConfirmationService],
})
export class PrimengModule {}
